import {call, put} from "typed-redux-saga";
import {Api} from "modules/utils";
import {
	fetchHelpPagesJsonFailed,
	fetchHelpPagesJsonSuccess,
	fetchChecksumsJSONFailed,
	fetchChecksumsJSONSuccess,
	fetchFAQJsonSuccess,
	fetchFAQJsonFailed,
} from "modules/actions";

export const fetchChecksumsJSONSaga = function* () {
	try {
		const result = yield* call(Api.JSON.checksums);
		yield* put(fetchChecksumsJSONSuccess(result));
	} catch (err) {
		yield* put(fetchChecksumsJSONFailed());
	}
};

export const fetchHelpPagesJSONSaga = function* () {
	try {
		const result = yield* call(Api.JSON.helpPages);
		yield* put(fetchHelpPagesJsonSuccess(result));
	} catch (e) {
		yield* put(fetchHelpPagesJsonFailed());
	}
};

export const fetchFAQJSONSaga = function* () {
	try {
		const result = yield* call(Api.JSON.faq);
		yield* put(fetchFAQJsonSuccess(result));
	} catch (e) {
		yield* put(fetchFAQJsonFailed());
	}
};

export const fetchHelpPageJsonsSaga = function* () {
	yield* call(fetchHelpPagesJSONSaga);
	yield* call(fetchFAQJSONSaga);
};
